import React from "react";
import Grid from "@mui/material/Grid2";
import ClientsTable from "./ClientsTable";

function Clients() {
  return (
    <>
      <Grid size={12}>
        <ClientsTable />
      </Grid>
    </>
  );
}

export default Clients;
